import { Pipe, PipeTransform } from '@angular/core';

import { Catalog } from '@mtna/pojo-consumer-ui';


@Pipe({
  name: 'rdsSortCatalogs'
})
export class RdsSortCatalogsPipe implements PipeTransform {
  transform(array: Catalog[]): Catalog[] {
    return [...array].sort((a: Catalog, b: Catalog) => {
      const aLabel = a.name || a.id;
      const bLabel = b.name || b.id;
      if (aLabel < bLabel) {
        return -1;
      } else if (aLabel > bLabel) {
        return 1;
      } else {
        return 0;
      }
    });
  }
}
